import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_CITY_LIST_REQUEST: '',
  GET_CITY_LIST_SUCCESS: '',
  GET_CITY_LIST_FAILURE: '',

};

types = setStoreTypeValues(types, 'authCity');

export default types;
